import { styled } from '@mui/material/styles';

interface FormsProps {
  gap?: number;
}

export const FormContainer = styled('div')<FormsProps>(({ theme, gap = 3 }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(gap),
}));

export const SubField = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
}));
